import { AppRoute } from "app";
import { useAtomValue, useSetAtom } from "jotai";

import { acceptOffer } from "api/acceptOffer";
import { declineOffer } from "api/declineOffer";
import { negotiateOffer } from "api/negotiateOffer";
import { sessionIdAtom } from "atoms/sessionId";
import { useEventTracking } from "hooks/useEventTracking";
import { usePageRouting } from "hooks/usePageRouting";

import { clientIdAtom } from "../../../atoms/clientId";
import { payeeFinalisedAtom } from "atoms/payeeFinalised";
import { clientConfigAtom } from "atoms/clientConfig";

export const useSubmitOfferResponse = () => {
  const sessionId = useAtomValue(sessionIdAtom);
  const clientId = useAtomValue(clientIdAtom);
  const setPayeeFinalised = useSetAtom(payeeFinalisedAtom);
  const {
    speedyPayment,
  } = useAtomValue(clientConfigAtom);

  const { navigateTo } = usePageRouting();
  const { trackEvent } = useEventTracking();

  const acceptSTPOffer = async () => {
    await acceptOffer(sessionId, clientId);
    trackEvent({ name: "Accept speedy payment" });
    navigateTo(AppRoute.PaymentAccepted);
  };

  const declineSTPOffer = async () => {
    await declineOffer(sessionId, clientId);
    trackEvent({ name: "Decline speedy payment" });
    setPayeeFinalised(true);
    navigateTo(AppRoute.TalkToClaimHandler);
  };

  const negotiateSTPOffer = async (counterOffer: number) => {
    await negotiateOffer(sessionId, clientId, counterOffer);
    trackEvent({ name: "Negotiate speedy payment" });
    navigateTo(AppRoute.TalkToClaimHandler);
  };

  const acceptSTPOfferPayee = async () => {
    trackEvent({ name: "Accept speedy payment - payee" });
    navigateTo(speedyPayment?.questions ? AppRoute.PayeeAcceptance : AppRoute.PayeeDetails);
  };

  return {
    acceptSTPOffer,
    declineSTPOffer,
    negotiateSTPOffer,
    acceptSTPOfferPayee
  };
};
